"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledTasksApi = exports.ScheduledTasksApiFactory = exports.ScheduledTasksApiFp = exports.ScheduledTasksApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * ScheduledTasksApi - axios parameter creator
 * @export
 */
const ScheduledTasksApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string | null} dagId
         * @param {string | null} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceApplyCurrentVersion: (dagId_1, taskId_1, ...args_1) => __awaiter(this, [dagId_1, taskId_1, ...args_1], void 0, function* (dagId, taskId, options = {}) {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksResourceApplyCurrentVersion', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksResourceApplyCurrentVersion', 'taskId', taskId);
            const localVarPath = `/scheduled-tasks/airflow/{dagId}/{taskId}/apply-current-version`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string | null} dagId
         * @param {string | null} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetAirflowTaskConfig: (dagId_2, taskId_2, ...args_2) => __awaiter(this, [dagId_2, taskId_2, ...args_2], void 0, function* (dagId, taskId, options = {}) {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksResourceGetAirflowTaskConfig', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksResourceGetAirflowTaskConfig', 'taskId', taskId);
            const localVarPath = `/scheduled-tasks/airflow/{dagId}/{taskId}/config`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string | null} dagId
         * @param {string | null} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetAirflowTaskHistories: (dagId_3, taskId_3, ...args_3) => __awaiter(this, [dagId_3, taskId_3, ...args_3], void 0, function* (dagId, taskId, options = {}) {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksResourceGetAirflowTaskHistories', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksResourceGetAirflowTaskHistories', 'taskId', taskId);
            const localVarPath = `/scheduled-tasks/airflow/{dagId}/{taskId}/histories`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string | null} dagId
         * @param {string | null} taskId
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetPythonTaskTestJobData: (dagId_4, taskId_4, referenceTime_1, ...args_4) => __awaiter(this, [dagId_4, taskId_4, referenceTime_1, ...args_4], void 0, function* (dagId, taskId, referenceTime, options = {}) {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksResourceGetPythonTaskTestJobData', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksResourceGetPythonTaskTestJobData', 'taskId', taskId);
            const localVarPath = `/scheduled-tasks/airflow/{dagId}/{taskId}/test-data`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (referenceTime !== undefined) {
                for (const [key, value] of Object.entries(referenceTime)) {
                    localVarQueryParameter[key] = value;
                }
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} templateId
         * @param {string} versionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetTaskTemplateVersion: (templateId_1, versionId_1, ...args_5) => __awaiter(this, [templateId_1, versionId_1, ...args_5], void 0, function* (templateId, versionId, options = {}) {
            // verify required parameter 'templateId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksResourceGetTaskTemplateVersion', 'templateId', templateId);
            // verify required parameter 'versionId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksResourceGetTaskTemplateVersion', 'versionId', versionId);
            const localVarPath = `/scheduled-tasks/templates/{templateId}/{versionId}/version`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetTaskTemplateVersions: (templateId_2, ...args_6) => __awaiter(this, [templateId_2, ...args_6], void 0, function* (templateId, options = {}) {
            // verify required parameter 'templateId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksResourceGetTaskTemplateVersions', 'templateId', templateId);
            const localVarPath = `/scheduled-tasks/templates/{templateId}/version-ids`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetTaskTemplates: (...args_7) => __awaiter(this, [...args_7], void 0, function* (options = {}) {
            const localVarPath = `/scheduled-tasks/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean | null} [run]
         * @param {ScheduledTaskDTO} [scheduledTaskDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceUpdateAirflowTaskConfig: (run_1, scheduledTaskDTO_1, ...args_8) => __awaiter(this, [run_1, scheduledTaskDTO_1, ...args_8], void 0, function* (run, scheduledTaskDTO, options = {}) {
            const localVarPath = `/scheduled-tasks/airflow/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (run !== undefined) {
                localVarQueryParameter['run'] = run;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(scheduledTaskDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceUploadTaskCode: (...args_9) => __awaiter(this, [...args_9], void 0, function* (options = {}) {
            const localVarPath = `/scheduled-tasks/code/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ScheduledTasksApiAxiosParamCreator = ScheduledTasksApiAxiosParamCreator;
/**
 * ScheduledTasksApi - functional programming interface
 * @export
 */
const ScheduledTasksApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ScheduledTasksApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string | null} dagId
         * @param {string | null} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceApplyCurrentVersion(dagId, taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksResourceApplyCurrentVersion(dagId, taskId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScheduledTasksApi.scheduledTasksResourceApplyCurrentVersion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string | null} dagId
         * @param {string | null} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetAirflowTaskConfig(dagId, taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksResourceGetAirflowTaskConfig(dagId, taskId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScheduledTasksApi.scheduledTasksResourceGetAirflowTaskConfig']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string | null} dagId
         * @param {string | null} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetAirflowTaskHistories(dagId, taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksResourceGetAirflowTaskHistories(dagId, taskId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScheduledTasksApi.scheduledTasksResourceGetAirflowTaskHistories']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string | null} dagId
         * @param {string | null} taskId
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetPythonTaskTestJobData(dagId, taskId, referenceTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksResourceGetPythonTaskTestJobData(dagId, taskId, referenceTime, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScheduledTasksApi.scheduledTasksResourceGetPythonTaskTestJobData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} templateId
         * @param {string} versionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetTaskTemplateVersion(templateId, versionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksResourceGetTaskTemplateVersion(templateId, versionId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScheduledTasksApi.scheduledTasksResourceGetTaskTemplateVersion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetTaskTemplateVersions(templateId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksResourceGetTaskTemplateVersions(templateId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScheduledTasksApi.scheduledTasksResourceGetTaskTemplateVersions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetTaskTemplates(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksResourceGetTaskTemplates(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScheduledTasksApi.scheduledTasksResourceGetTaskTemplates']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {boolean | null} [run]
         * @param {ScheduledTaskDTO} [scheduledTaskDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceUpdateAirflowTaskConfig(run, scheduledTaskDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksResourceUpdateAirflowTaskConfig(run, scheduledTaskDTO, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScheduledTasksApi.scheduledTasksResourceUpdateAirflowTaskConfig']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceUploadTaskCode(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksResourceUploadTaskCode(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScheduledTasksApi.scheduledTasksResourceUploadTaskCode']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.ScheduledTasksApiFp = ScheduledTasksApiFp;
/**
 * ScheduledTasksApi - factory interface
 * @export
 */
const ScheduledTasksApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ScheduledTasksApiFp)(configuration);
    return {
        /**
         *
         * @param {ScheduledTasksApiScheduledTasksResourceApplyCurrentVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceApplyCurrentVersion(requestParameters, options) {
            return localVarFp.scheduledTasksResourceApplyCurrentVersion(requestParameters.dagId, requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ScheduledTasksApiScheduledTasksResourceGetAirflowTaskConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetAirflowTaskConfig(requestParameters, options) {
            return localVarFp.scheduledTasksResourceGetAirflowTaskConfig(requestParameters.dagId, requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ScheduledTasksApiScheduledTasksResourceGetAirflowTaskHistoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetAirflowTaskHistories(requestParameters, options) {
            return localVarFp.scheduledTasksResourceGetAirflowTaskHistories(requestParameters.dagId, requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ScheduledTasksApiScheduledTasksResourceGetPythonTaskTestJobDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetPythonTaskTestJobData(requestParameters, options) {
            return localVarFp.scheduledTasksResourceGetPythonTaskTestJobData(requestParameters.dagId, requestParameters.taskId, requestParameters.referenceTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ScheduledTasksApiScheduledTasksResourceGetTaskTemplateVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetTaskTemplateVersion(requestParameters, options) {
            return localVarFp.scheduledTasksResourceGetTaskTemplateVersion(requestParameters.templateId, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ScheduledTasksApiScheduledTasksResourceGetTaskTemplateVersionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetTaskTemplateVersions(requestParameters, options) {
            return localVarFp.scheduledTasksResourceGetTaskTemplateVersions(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceGetTaskTemplates(options) {
            return localVarFp.scheduledTasksResourceGetTaskTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ScheduledTasksApiScheduledTasksResourceUpdateAirflowTaskConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceUpdateAirflowTaskConfig(requestParameters = {}, options) {
            return localVarFp.scheduledTasksResourceUpdateAirflowTaskConfig(requestParameters.run, requestParameters.scheduledTaskDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksResourceUploadTaskCode(options) {
            return localVarFp.scheduledTasksResourceUploadTaskCode(options).then((request) => request(axios, basePath));
        },
    };
};
exports.ScheduledTasksApiFactory = ScheduledTasksApiFactory;
/**
 * ScheduledTasksApi - object-oriented interface
 * @export
 * @class ScheduledTasksApi
 * @extends {BaseAPI}
 */
class ScheduledTasksApi extends base_1.BaseAPI {
    /**
     *
     * @param {ScheduledTasksApiScheduledTasksResourceApplyCurrentVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTasksApi
     */
    scheduledTasksResourceApplyCurrentVersion(requestParameters, options) {
        return (0, exports.ScheduledTasksApiFp)(this.configuration).scheduledTasksResourceApplyCurrentVersion(requestParameters.dagId, requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ScheduledTasksApiScheduledTasksResourceGetAirflowTaskConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTasksApi
     */
    scheduledTasksResourceGetAirflowTaskConfig(requestParameters, options) {
        return (0, exports.ScheduledTasksApiFp)(this.configuration).scheduledTasksResourceGetAirflowTaskConfig(requestParameters.dagId, requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ScheduledTasksApiScheduledTasksResourceGetAirflowTaskHistoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTasksApi
     */
    scheduledTasksResourceGetAirflowTaskHistories(requestParameters, options) {
        return (0, exports.ScheduledTasksApiFp)(this.configuration).scheduledTasksResourceGetAirflowTaskHistories(requestParameters.dagId, requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ScheduledTasksApiScheduledTasksResourceGetPythonTaskTestJobDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTasksApi
     */
    scheduledTasksResourceGetPythonTaskTestJobData(requestParameters, options) {
        return (0, exports.ScheduledTasksApiFp)(this.configuration).scheduledTasksResourceGetPythonTaskTestJobData(requestParameters.dagId, requestParameters.taskId, requestParameters.referenceTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ScheduledTasksApiScheduledTasksResourceGetTaskTemplateVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTasksApi
     */
    scheduledTasksResourceGetTaskTemplateVersion(requestParameters, options) {
        return (0, exports.ScheduledTasksApiFp)(this.configuration).scheduledTasksResourceGetTaskTemplateVersion(requestParameters.templateId, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ScheduledTasksApiScheduledTasksResourceGetTaskTemplateVersionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTasksApi
     */
    scheduledTasksResourceGetTaskTemplateVersions(requestParameters, options) {
        return (0, exports.ScheduledTasksApiFp)(this.configuration).scheduledTasksResourceGetTaskTemplateVersions(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTasksApi
     */
    scheduledTasksResourceGetTaskTemplates(options) {
        return (0, exports.ScheduledTasksApiFp)(this.configuration).scheduledTasksResourceGetTaskTemplates(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ScheduledTasksApiScheduledTasksResourceUpdateAirflowTaskConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTasksApi
     */
    scheduledTasksResourceUpdateAirflowTaskConfig(requestParameters = {}, options) {
        return (0, exports.ScheduledTasksApiFp)(this.configuration).scheduledTasksResourceUpdateAirflowTaskConfig(requestParameters.run, requestParameters.scheduledTaskDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTasksApi
     */
    scheduledTasksResourceUploadTaskCode(options) {
        return (0, exports.ScheduledTasksApiFp)(this.configuration).scheduledTasksResourceUploadTaskCode(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ScheduledTasksApi = ScheduledTasksApi;
//# sourceMappingURL=scheduled-tasks-api.js.map